module.exports = __webpack_public_path__ + "img/Scan.d4e6c467.svg";